import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CignaIconComponent } from '../../components/cigna-icon/cigna-icon.component';

@Component({
  selector: 'app-modal-contacto',
  templateUrl: './modal-contacto.component.html',
  standalone: true,
  imports: [CignaIconComponent, TranslateModule],
})
export class ModalContactoComponent implements OnInit {
  onTime: boolean = false;

  ngOnInit(): void {
    const time = new Date();
    if (time.getDay() < 6) {
      if (time.getHours() >= 8 && time.getHours() < 20) {
        this.onTime = true;
      }
    }
  }
}
